var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVodafone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3059 2.49594C31.3576 2.91316 29.075 5.65355 29.018 8.99133C33.098 9.74044 36.1795 12.4713 36.1795 17.3453C36.1795 22.0485 32.2611 25.8509 27.3631 25.8509C22.4936 25.8604 18.5467 21.5933 18.5467 16.0651C18.5467 8.44136 25.3373 2.11665 33.9255 2.31578C31.9187 1.42444 29.7027 0.921875 27.3631 0.921875C18.5182 0.921875 11.3376 8.07155 11.3376 16.8996C11.3376 25.7276 18.5182 32.8773 27.3631 32.8773C36.208 32.8773 43.3886 25.7276 43.3886 16.8996C43.3886 10.5559 39.6794 5.07513 34.3059 2.49594Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodafone);
export default __webpack_public_path__ + "static/media/vodafone.a6c1a2b74cffd6984d647c4010d73155.svg";
export { ForwardRef as ReactComponent };